import { createSelector } from 'reselect';
 
const selectTenantDomains = (state: any) => state.tenantDomains;
 
export const selectTenantDomainsCurrentItem = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.current);
 
export const selectTenantDomainsListItems = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.list);
 
 
export const selectTenantDomainsItemById = (itemId: any) =>
    createSelector(selectTenantDomainsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectTenantDomainsQueryItems = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.query);

export const selectTenantDomainsCreatedItem = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.create);
 
export const selectTenantDomainsUpdatedItem = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.update);
 
export const selectTenantDomainsReadItem = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.read);
 
export const selectTenantDomainsDeletedItem = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.delete);
 
export const selectTenantDomainsSearchedItems = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.search);
 
export const selectTenantDomainsItemsCount = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.count);
 
export const selectTenantDomainsItemsFilter = createSelector([selectTenantDomains], (tenantDomains) => tenantDomains.filter);